import React, { Component } from 'react'
import Seo from "./Seo"
import Footer from './Footer'


class RefundPolicy extends Component {
  render() {
    return (
      <div>
        <div className='container mt-5'>
          <h1 className='py-5'>Refund Policy</h1>
          <p>Pulse Labs uses third party payment gateway for facilitating transfer of money from client’s
            bank account to Pulse Labs Account as Technology Fee.<br></br><br></br> The subscription period of 365 days will
            be activated from the day of receipt of the funds. This is over and above the 30 days free trial
            period offered to the client.<br></br><br></br> For performing Mutual Fund Transactions, Pulse Labs uses the BSE
            Exchange Star Platform as its infrastructure partner. Clients can only use their bank account registered
            with Pulse Labs as part of the Account Opening which is further passed to BSE and not any other bank account
            for the buying any Mutual Fund.<br></br><br></br> In the case of Mutual Fund Transactions, money does not reach Pulse Labs
            but is remitted to the bank accounts of Asset Management Companies via the payment gateway system of
            BSE Star.<br></br><br></br>Transactions will be completed only after successful transfer of money from the client’s bank
            account registered with Pulse Labs/BSE Star.<br></br><br></br> In case of successful transfer of money but failure of investment
            transaction, money would be refunded within 72 hours to the registered bank account.</p>
        </div>
        <Footer />
        <Seo />
      </div>
    )
  }
}

export default RefundPolicy